import React from "react";
import "./ReviewCard.scss"
import star from "../../assets/star.svg"
const ReviewCard = ({ data }) => {
    return (
        <div className="ReviewCard">
            <div className="ReviewCard-rate">
                {[...Array(data?.rating)].map((_, key) => {
                    return (
                        <img alt="" src={star} key={key} />
                    )
                })}
            </div>
            <div className="ReviewCard-review">
                {data?.review}
            </div>
            <div className="ReviewCard-reviewer">{data?.name}
            </div>
            <div className="ReviewCard-designation">{data?.designation}
            </div>
        </div>
    )
}
export default ReviewCard